export default "__VITE_ASSET__C5IXr$vW__"